import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=3807c214&scoped=true&"
import script from "./BaseInfo.vue?vue&type=script&lang=js&"
export * from "./BaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=3807c214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807c214",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3807c214')) {
      api.createRecord('3807c214', component.options)
    } else {
      api.reload('3807c214', component.options)
    }
    module.hot.accept("./BaseInfo.vue?vue&type=template&id=3807c214&scoped=true&", function () {
      api.rerender('3807c214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/publishGoods/components/BaseInfo.vue"
export default component.exports